export default __webpack_public_path__ + "static/media/Charity.d51a4601.png";